export default __webpack_public_path__ + "assets/overview.864bab465223cd22c41830c7bb9c1813.png";